import { useEffect, useState } from 'react'
import { n_achievement } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { ICON_TROPHY } from '../../../modules/images'

const LevelUpCallout = ({ totalCount }) => {
  const { t } = useTranslation()
  const [randomPhrase, setRandomPhrase] = useState('')

  const phrases = [
    t(n_achievement.banner_random1),
    t(n_achievement.banner_random2),
    t(n_achievement.banner_random3),
    t(n_achievement.banner_random4),
    t(n_achievement.banner_random5),
    t(n_achievement.banner_random6),
    t(n_achievement.banner_random7),
    t(n_achievement.banner_random8),
    t(n_achievement.banner_random9),
    t(n_achievement.banner_random10),
  ]

  const getRandomQuote = () => {
    const randomIndex = Math.floor(Math.random() * phrases.length)
    setRandomPhrase(phrases[randomIndex])
  }

  useEffect(() => {
    getRandomQuote()
  }, [])

  return (
    <div className="relative mb-16 flex w-full flex-col items-center rounded-[8px] bg-purple-50 p-12 sm:mb-20">
      <img className="mb-8 h-[60px] w-[60px]" src={ICON_TROPHY} alt="icon trophy" />
      {/** 1/26 스펙 아웃 */}
      {/* <QIcon_close_default className="absolute top-12 right-12 h-[20px] w-[20px] cursor-pointer" /> */}
      <div className="Body1-16Bd mb-4">{t(n_achievement.banner(totalCount))}</div>
      <div className="Body2-14Md">{randomPhrase}</div>
    </div>
  )
}

export default LevelUpCallout
